import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'

import wizardsShape from 'core/components/wizard/shapes'
import PageLoading from 'core/components/page-loading'
import { injectIntl, FormattedMessage } from 'react-intl'
import * as routes from 'core/routing/constants/index'

import styled from 'styled-components'
import Hydrator, { hydratorMethods, hydratorOrigins } from 'core/hydrator'
import { Row, Col, ButtonPrimary, notification } from 'core/components/ui'

import MainContentWrapper from 'core/templates/MainContentWrapper'
import { font, greys } from 'assets/themes/theme-default'
import VehicleDetail from 'core/layouts/vehicle-detail'
import TitleIcon from 'core/layouts/title-icon'
import { PROVIDER_NUMBERPLATE_AUTOBIZ } from 'core/utils/enums/providerNumberplate'
import { tradeInShape } from '../shapes'
import configurationShape from '../../configuration/shapes'

const StyledPageLoading = styled(PageLoading)`
  padding: 75px 0 50px;
`

const Title = styled.h2`
  color: ${greys.dark1};
  text-transform: uppercase;
  font-weight: ${font.weight.extrabold};
  font-size: ${font.size.lgsm};
  margin: 65px 0 10px;
`
const SubTitle = styled.h4`
  color: ${props => props.theme.colors.color1.bg};
  font-weight: ${font.weight.base};
  margin: 15px 0;
`

const VehicleConfirm = props => {
  const { setWizards, wizards, history, tradeIn, setTradeIn, configuration, intl, carInformations } = props
  const [isValidMake, setIsValidMake] = useState(true)

  const { vehicle } = tradeIn
  const { campaign, tradeInContext } = configuration
  const { deactivatedMakes } = campaign

  const {
    id,
    dateOfRegistration,
    chassis,
    registration,
    catalog,
  } = vehicle

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex =
      aStepsActive.findIndex(step => step.hash === routes.TRADEIN_VEHICLE_CONFIRM) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }

    setWizards(extentedWizards)
  }

  useEffect(() => {
    const runIt = informations => {
      const itemExtended = {
        ...tradeIn.vehicle,
        ...informations,
        id,
        putIntoService: dateOfRegistration,
        chassis,
        registration,
        numberplate: vehicle.numberplate,
        externalColorWording: vehicle.externalColorWording,
        configuration: 3,
        module: 2,
        prices: vehicle.prices,
        catalog
      }

      const newVehicle = Hydrator.hydrate(
        hydratorMethods.HYDRATE_VEHICLE,
        itemExtended,
        hydratorOrigins.ORIGIN_DETAIL
      )
      // Here we get curbWeight value from Numberplate provider if the referential is Autobiz
      // because Autobiz only send this data through numberplate provider
      let { curbWeight } = newVehicle
      if (
        configuration.providerConfiguration.providerNumberplateId === PROVIDER_NUMBERPLATE_AUTOBIZ
      ) {
        ;({ curbWeight } = tradeIn.vehicle)
      }
      setTradeIn({
        ...tradeIn,
        vehicle: {
          ...newVehicle,
          price: 0,
          prices: {
            totalOptionsPrice: 0,
            totalServiceContractsPrice: 0,
            totalPaintPrice: 0,
            totalSaddleries: 0
          },
          curbWeight
        }
      })

      if (deactivatedMakes.includes(informations.makeId)) {
        setIsValidMake(false)
      } else {
        activateNextStep()
      }
    }

    if (!tradeInContext.loading && carInformations) runIt(carInformations)
  }, [carInformations])

  useEffect(() => {
    if (!isValidMake) {
      notification.error({
        message: intl.formatMessage({ id: 'tradeIn-vehicle-confirm-inactive-make-subtitle-1' })
      })
    }
  }, [isValidMake])

  useEffect(() => {
    // Redirection if direct access & step is not active

    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.TRADEIN_VEHICLE_CONFIRM
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    /*const { colorsList } = filtersList
    const { exterior, interior } = colorsList

    if (exterior && interior) return*/
  }, [])

  // first div => for animations
  return (
    <div>
      <MainContentWrapper>
        <TitleIcon
          cssId="globaldealer-title-2"
          title={intl.formatMessage({
            id: 'tradeIn-vehicle-confirm-view-subtitle'
          })}
        />
        {!carInformations ? (
          <>
            <Title data-test="error-page-title">
              <FormattedMessage id="tradeIn-vehicle-confirm-error-title-1" />
            </Title>
            <SubTitle data-test="error-page-subtitle">
              <FormattedMessage id="tradeIn-vehicle-confirm-error-subtitle-1" />
            </SubTitle>
            <ButtonPrimary onClick={() => document.location.reload(true)}>
              <FormattedMessage id="tradeIn-vehicle-confirm-error-button-1" />
            </ButtonPrimary>
          </>
        ) : (
          <Row type="flex" gutter={20}>
            <Col span={24}>
              {vehicle.prices ? <VehicleDetail vehicle={vehicle} /> : <StyledPageLoading /> }
            </Col>
          </Row>
        )}
      </MainContentWrapper>
    </div>
  )
}

VehicleConfirm.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  intl: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  configuration: configurationShape.isRequired,
  carInformations: PropTypes.object.isRequired
}

export default withRouter(injectIntl(VehicleConfirm))
